import type { HelpFile } from '../../types/help'
import { SectionPageHeaderTestIds } from '../../../testids/SectionPageHeaderTestIds'

export const sectionPageHeaderHelp: HelpFile = {
  texts: {
    [SectionPageHeaderTestIds.sectionPageHeaderTitle]: null,
    [SectionPageHeaderTestIds.sectionPageHeaderDescription]: null,
  },
}
